import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const sdkVersionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSdkVersions: builder.query({
      query: () => `/sdk_versions`,
      providesTags: (result, error, arg) => [{ type: 'SdkVersion', id: 'LIST' }],
    }),
    getSdkVersion: builder.query({
      query: (sdkVersion) => `/sdk_versions/${sdkVersion}`,
      providesTags: (result, error, arg) => [{ type: 'SdkVersion', id: arg }],
    }),
    updateSdkVersion: builder.mutation({
      query: (sdkVersion) => ({
        url: `sdk_versions/${sdkVersion.slug}`,
        method: 'PUT',
        body: sdkVersion,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {slug}) => [{ type: 'SdkVersion', id: slug }],

    })
  }),
  overrideExisting: false
})

export const {
  useGetSdkVersionsQuery,
  useGetSdkVersionQuery,
  useUpdateSdkVersionMutation
} = sdkVersionApiSlice
